import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRightIcon, DownloadIcon } from 'lucide-react';
export function CTASection() {
  return <section id="contact" className="py-24 relative overflow-hidden" data-id="element-93" data-mp="27h5n7kn6igcr">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy to-slate z-0" data-id="element-94" data-mp="2cefaatn3ifxf"></div>
      <div className="absolute inset-0 bg-grid-pattern opacity-20 z-0" data-id="element-95" data-mp="2hfmmr606o3af"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-96" data-mp="2mepmqc1b3jbj">
        <FadeIn data-id="element-97" data-mp="2qf9ltl5fwx0b">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-98" data-mp="2qeq3w4fsi8ma">
            Ready to Future-Proof Your Institution?
          </h2>
          <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto" data-id="element-99" data-mp="2v6zzo13l62wh">
            Schedule a confidential briefing with our team to explore how FIQIS
            can strengthen your security, unlock new revenue, and modernize your
            infrastructure.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-100" data-mp="3a4aad88en4r5">
            <a href="mailto:arthur@fiqis.com?subject=Meeting%20Request%20-%20FiQIS" className="w-full sm:w-auto bg-teal hover:bg-teal-400 text-navy font-bold px-8 py-4 rounded-md transition-all duration-300 hover:shadow-[0_0_20px_rgba(0,212,170,0.4)] flex items-center justify-center gap-2 text-lg" data-id="element-101" data-mp="2179qkjeusd6a">
              Request a Meeting
              <ArrowRightIcon className="w-5 h-5" data-id="element-102" data-mp="2jwgcsgeuvmwu" />
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}